<template>
  <div>
    <b-modal
      id="modal-ajoutprod"
      hide-footer
      centered
      title=" "
      ref="addproduct"
      style="position: relative"
    >
      <GStockLoader :loading="loading" />
      <form @submit.prevent>
        <h6 class="heading-small text-muted mb-4">Ajouter Article</h6>

        <div class="pl-lg-4">
          <div class="row">
            <div class="col-lg-6">
              <!-- <base-input
                alternative
                label="Nom de l'article"
                placeholder="Nom de l'article"
                input-classes="form-control-alternative"
                v-model="product.name"
              /> -->
              <ProductSPInput
                @newName="product.name = $event"
                @form="setForm"
                @attributes="attributes = $event"
              />
            </div>
            <div
              class="col-lg-6"
              v-for="(attr, index) in attributes"
              :key="index"
            >
              <b-form-group
                :label="attr"
                v-if="values[attr] && values[attr].length > 0"
              >
                <b-form-radio-group
                  :id="'btn-radios-' + index"
                  v-model="form[attr]"
                  :options="values[attr]"
                  name="radios-btn-default"
                  buttons
                ></b-form-radio-group>
              </b-form-group>
              <base-input
                v-else
                alternative
                :label="attr"
                :placeholder="attr"
                input-classes="form-control-alternative"
                v-model="form[attr]"
              />
            </div>
            <div class="col-lg-6">
              <base-input
                alternative
                label="Prix"
                placeholder="Prix"
                input-classes="form-control-alternative"
                v-model="price"
              />
            </div>
            <div class="col-lg-6">
              <base-input
                alternative
                label="Pourcentage en %"
                placeholder="Pourcentage en %"
                input-classes="form-control-alternative"
                v-model="percentage"
                @input="onPercentageInput"

              />
            </div>

            <div
              class="col-lg-6"
              style="
                display: flex;
                justify-content: flex-start;
                align-items: center;
              "
            >
            <base-input
                alternative
                label= "En main  "
                placeholder="Pourcentage en %"
                input-classes="form-control-alternative"
                v-model="originalPrice"
                @input="onOriginalPriceInput"

              />
    DT 
            </div>
            <div class="col-lg-12">
              Crédit
              <b-dropdown
                id="dropdown-1"
                :text="credit ? 'Oui' : 'Non'"
                class="m-md-2"
              >
                <b-dropdown-item @click="credit = 1">Oui</b-dropdown-item>
                <b-dropdown-item @click="credit = 0">Non</b-dropdown-item>
              </b-dropdown>
            </div>

            <!-- <div class="col-lg-12">
              <b-dropdown id="dropdown-1" :text="getText" class="m-md-2">
                <b-dropdown-item @click="selectedValidity = 30"
                  >30 jours</b-dropdown-item
                >
                <b-dropdown-item @click="selectedValidity = 90"
                  >90 jours</b-dropdown-item
                >
              </b-dropdown>
            </div> -->
            <div class="col-lg-12">
              <b-form-group
                id="input-group-5"
                label="Déposant"
                label-for="input-5"
              >
                <b-form-input
                  list="collection-id"
                  v-model="product.owner"
                ></b-form-input>

                <datalist id="collection-id">
                  <option
                    v-for="client in clients"
                    :value="client.value"
                    :key="client.value"
                  >
                    {{ client.text }}
                  </option>
                </datalist>
              </b-form-group>
            </div>
            <div class="col-lg-6" style="padding-left: 0px">
              <b-dropdown id="dropdown-1" :text="getText" class="m-md-2">
                <b-dropdown-item @click="selectedValidity = 30"
                  >30 jours</b-dropdown-item
                >
                <b-dropdown-item @click="selectedValidity = 90"
                  >90 jours</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <div class="col-12">
              <i
                >* Par défaut la durée de validité d'un article est fixée à
                {{ defaultValidity }} jours.</i
              >
            </div>
          </div>
        </div>

        <hr class="my-4" />
        <!-- Description -->
        <center>
          <b-btn
            type="submit"
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            @click="postProduct($event)"
            >Ajouter</b-btn
          >
        </center>
      </form>
    </b-modal>
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import ProductSPInput from "./ProductSPInput";
import { get, post, postFile } from "@/mixins/api";
import constants from "@/mixins/constants";
export default {
  name: "ModalAddProduit",
  components: {
    GStockLoader,
    ProductSPInput,
  },
  mixins: [constants],
  data() {
    return {
      values: {},
      attributes: [],
      form: {},
      search: "",
      imagesToUpload: [],
      images: [],
      name: "",

      model: {
        categorie: null,

        titre: "",
        description: "",
        prix: "",
      },
      clients: [],
      product: {
        name: "",
        price: 0.0,
        credit: 0,
        percentage: 0.2,
        owner: null,
      },
      price: 0.0,
      credit: 0,
      originalPrice: 0.0,
      percentage: 20,
      loading: false,
        selectedValidity: undefined,
        manualOriginalPrice: false,
        manualPercentage: false, // Flag to track manual input

    };
  },
  watch: {
    defaultPercentageMath: {
      handler: function (newVal) {
        this.product.percentage = this.defaultPercentageMath;
        this.percentage = this.defaultPercentageText;
      },
      immediate: true,
    }  , price: {
      handler: function (newVal) {
        this.calculatePriceFromPrice();
      },
    },
    originalPrice: {
      handler: function (newVal) {
        if (this.manualOriginalPrice) {
          this.calculatePercentageFromOriginalPrice();
        }
      },
    },
    percentage: {
      handler: function (newVal) {
        if (this.manualPercentage) {
          this.calculatePriceFromPercentage();
        }
      },
    },
  },
  computed: {
    getText() {
      return !this.selectedValidity
        ? "Validité du produit"
        : this.selectedValidity == 30
        ? "30 jours"
        : this.selectedValidity == 90
        ? "90 jours"
        : "30 jours";
    },
  },
  methods: {
    setForm(form, values) {
      this.form = form;
      this.values = values || {};
    },
    calculatePriceFromPrice() {
      try {
        if (isNaN(this.price) || this.price === "") throw "";
        const price = parseFloat(this.price);
        if (!this.manualOriginalPrice) {
          this.originalPrice = (price * (1 - this.percentage / 100)).toFixed(2);
        }
        if (!this.manualPercentage) {
          this.percentage = ((1 - this.originalPrice / price) * 100).toFixed(2);
        }
      } catch (exception) {
        this.originalPrice = 0.0;
      }
    },
    onOriginalPriceInput() {
      this.manualOriginalPrice = true;
      this.manualPercentage = false;
      this.calculatePercentageFromOriginalPrice();
    },
    onPercentageInput() {
      this.manualPercentage = true;
      this.manualOriginalPrice = false;
      this.calculatePriceFromPercentage();
    },
    calculatePercentageFromOriginalPrice() {
      try {
        if (isNaN(this.originalPrice) || this.originalPrice === "") throw "";
        const originalPrice = parseFloat(this.originalPrice);
        if (this.price != 0) {
          this.percentage = ((1 - originalPrice / this.price) * 100).toFixed(2);
        }
      } catch (exception) {
        this.percentage = 20;
      }
    },
    calculatePriceFromPercentage() {
      try {
        if (isNaN(this.percentage) || this.percentage === "") throw "";
        const percentage = parseFloat(this.percentage);
        this.originalPrice = (this.price * (1 - percentage / 100)).toFixed(2);
      } catch (exception) {
        this.originalPrice = 0.0;
      }
    },
    handleSelects(e) {
      this.images = [];
      this.imagesToUpload = e.target.files;
      console.log(this.imagesToUpload);
      let fileList = Array.prototype.slice.call(e.target.files);
      fileList.forEach((f) => {
        if (!f.type.match("image.*")) {
          return;
        }

        let reader = new FileReader();
        let that = this;

        reader.onload = function (e) {
          that.images.push(e.target.result);
        };
        reader.readAsDataURL(f);
      });
    },
    getClients() {
      get("clients").then((response) => {
        this.clients = response.data.data.map((it) => {
          return { text: it.fullname, value: it.id };
        });
      });
    },
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Ajout produit.",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
    postProduct(e) {
      e.stopPropagation();
      try {
        const stop =
          isNaN(this.originalPrice) ||
          isNaN(this.percentage) ||
          this.originalPrice == "" ||
          this.percentage == "";
        const price = parseFloat(this.price);
        const val = this.percentage;
        const percentage = parseFloat(val) / 100;
        if (
          this.product.owner != null &&
          price != 0 &&
          percentage != 0 &&
          this.product.name != "" &&
          !stop
        ) {
          this.product.price = price;
          this.product.credit = this.credit;
          this.product.percentage = percentage;
          this.product.validity = this.selectedValidity
            ? this.selectedValidity
            : this.defaultValidity;
          this.loading = true;
          this.product.attributes = "";
          const attr = [];
          Object.keys(this.form).forEach((element) => {
            attr.push(`${element}(:)${this.form[element]}`);
          });
          if (attr.length != 0) {
            this.product.attributes = attr.join(";");
          }
          post("product", this.product)
            .then((res) => {
              this.$emit("added");
              this.$refs.addproduct.hide();
            })
            .catch((err) => {
              this.makeToast("Une erreur est survenue merci de résseayez.");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          throw "Invalid product";
        }
      } catch (e) {
        console.log(e);
        this.makeToast("Vérifiez les données que vous avez saisit.");
      }
    },
  },
  mounted() {
    this.getClients();
  },
};
</script>
                        
  
<style lang="scss" scoped>
img {
  float: left;
  border-style: none;
  width: 100px;
  height: 80px;
}
</style>
<style>
#modal-ajoutprod .btn-group-toggle {
  display: inline !important;
}
#modal-ajoutprod .btn-group-toggle label {
  margin: 3px !important;
}
</style>